"use strict";

var Backbone = require("backbone");
var $ = require("jquery");
var _ = require("underscore");
Backbone.$ = $;
var debug = require("debug")("views:ArticleResultView");

var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");

var SelectedDocumentModel = require("../../common/models/selected-document-model.js");
var HiglightedDocumentModel = require("../models/highlighted-document-model.js");
var DocumentOfTheDayModel = require("../models/document-of-the-day-model.js");

// ArticleResultView : affiche un résultat de recherche sur l'index article (recherhe avec texte) ou document (affichage couverture)
module.exports = Backbone.View.extend({

    tagName: "div",
    className: "page-result",
    events: {
        "click .select-document": "onSelectDocumentClicked",
        "click .selection": "onSelectDocumentClicked",
        "click .hl-document": "onHlDocumentClicked",
        "click .document-otd": "onDocumentOTDClicked",
        "click .share-facebook": "onShareFacebookClicked",
        "click .share-twitter": "onShareTwitterClicked"
    },

    template: null, // external template
    model: null, // PageResultModel
    pv5api: null, // pressview5 api url
    rnapi: null, // retronews api url
    cropWidth: 360, // crop width
    cropHeight: 200, // crop height
    cropFontSize: 13, // font size
    userModel: null, // user model
    app: null,
    queryModel:null,
    index:false, // index du résultat dans l'ensemble des résultats de la recherche
    from:'', // si indiqué, renseigne l'url appelante

    /**
     * @param  {[type]} options option must contain a query model and a template
     * @return {[type]}         [description]
     */
    initialize: function(options) {
        var T = this;
        _.extend(T, options);
        T.template = _.template(T.template);
    },

    /**
     * [render description]
     * @return {[type]} [description]
     */
    render: function() {
        debug("render");
        var T = this,
            context = T.model.toJSON();

        // defaults
        context.dateFR = "";
        context.publicationTitle = context.publicationTitle || "";
        context.documentTitle = context.documentTitle || "";

        context.reader = T.readerUrl();
        context.crop = T.cropUrl();

        context.cropWidth = T.cropWidth;
        context.cropHeight = T.cropHeight;

        context.published = context.published|| "1900-01-01";
        context.access = context.access || "public";
        context.query=T.queryModel.get("query");

        //todo : ajouter les paramètres de recherche alltems et someterms pour que le lecteur rejoue la recherche dans la page
        context.search = "";

        if(context.query=="document"||context.query=="document-cc"){
            context.documentTitle=context.title;
            context.pageNumber=null; // on n'affiche pas la page si on recherche des documents
            context.title=null;
            context.main=false;
        }
        else{
            if(context.title && context.title.length > 200){
                context.title=context.title.substr(0,200)+"...";
            }
        }

        // TODO à mettre en commun quelque part ?
        if(context.documentTitle){
            context.documentTitle=context.documentTitle.trim();
        }
        var regNumber = new RegExp("^[0-9]+$"); // 123
        var regNumberWithN = new RegExp("^N[0-9]+$"); // N123
        var regYearNumber = new RegExp("^A[0-9]+,N[0-9]+$"); // A5,N4523
        if (regNumber.test(context.documentTitle)) {
            context.documentTitle = "n°&nbsp;" + context.documentTitle;
        } else if(regNumberWithN.test(context.documentTitle)) {
            context.documentTitle = "n°&nbsp;" + context.documentTitle.substr(1);
        } else if(regYearNumber.test(context.documentTitle)) {
            var doc_title_split=context.documentTitle.split(",");
            context.documentTitle = "a.&nbsp;"+doc_title_split[0].substr(1)+", n°&nbsp;" + doc_title_split[1].substr(1);
        }

        T.$el.html(T.template(context));

        if (T.userModel.isAdmin() || T.userModel.isBnf()) {
            T.$(".menu").addClass("show");
        }

        T.$el.addClass("access-"+context.access);

        return T;
    },



    onSelectDocumentClicked: function() {
        var T = this,
            pubTitle = T.model.get("publicationTitle"),
            published = T.model.get("published"),
            documentId = T.model.get("documentId")||T.model.get("id"),
            publicationId = T.model.get("publicationId");

        if (!T.userModel.isLoggedIn()) {
            T.app.loginScreen();
            return;
        }

        T.app.notify({
            text: STR.save_in_progress + "...",
            type: "info",
            timeout: 3000
        });

        var se = new SelectedDocumentModel({
            documentId: documentId,
            publicationId: publicationId,
            publicationTitle: pubTitle,
            publicationDate: published
        }, {
            rnapi: T.rnapi
        });
        se.save(null, {
            success: function() {
                T.app.notify({
                    text: STR.save_ok,
                    type: "info",
                    timeout: 1000
                });
            },
            error: function() {
                T.app.notify({
                    text: STR.unable_to_save,
                    type: "error",
                    timeout: 4000
                });
            }
        });
    },

    readerUrl: function() {
        var T = this,
            document_id = T.model.get("documentId")||T.model.get("id"),
            publication_id = T.model.get("publicationId"),
            number = T.model.get("pageNumber")||T.model.get("firstPage"),
            publication_title = T.model.get("publicationTitle"),
            published = STR.date(T.model.get("published")),
            path = window.location.pathname + window.location.hash + "&total=" + T.queryModel.get("total"),
            article_id=T.model.get("articleId");

         var url= "/journal/" + UrlUtil.slugify(publication_title) + "/" + UrlUtil.slugify(published) + "/" + publication_id + "/" + document_id + "/" + number;
         if(article_id && article_id!="combined"){
             url+="/"+article_id;
         }
         if(T.from) {
            url+="?from=" + encodeURIComponent(T.from);
         }
         else {
            url+="?from=" + encodeURIComponent(path);
         }
       
         if(T.index !== false && T.index !== undefined) {
             url+="&index="+T.index;
         }

         return url;
    },

    cropUrl: function() {
        var T = this,
            documentId = T.model.get("documentId")||T.model.get("id"),
            publicationId = T.model.get("publicationId"),
            page_number = T.model.get("pageNumber")||T.model.get("firstPage"), // résultat article / résultat document
            highlight = T.model.get("highlight"),
            crop;

        var pageUrl = T.pv5api + "/document/" + publicationId + "/" + documentId + "/page/" + page_number;

        if (highlight && highlight.words && highlight.words.length) {
            crop = pageUrl + "/crop/" + T.cropWidth + "/" + T.cropHeight + "/" + T.cropFontSize;
            crop += "/words/" + highlight.words.join(",");
        } else {
            crop = pageUrl + "/thumbnail";
        }

        return crop;
    },

    onShareTwitterClicked: function() {
        var T = this,
            root = window.location.protocol + "//" + window.location.hostname,
            url = root + T.readerUrl(),
            pubTitle = T.model.get("publicationTitle"),
            published = T.model.get("published"),
            message = pubTitle + ", " + STR.date(published); // use template ?

        if (T.app.hostname) {
            var url_obj = new URL(url);
            url_obj.hostname = T.app.hostname;
            url = url_obj.href;
        }

        window.open(UrlUtil.shareTwitter(message, url, "RetroNewsFR"), "_blank");
    },

    onShareFacebookClicked: function() {
        //https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4
        var T = this,
            root = window.location.protocol + "//" + window.location.hostname,
            url = root + T.readerUrl(),
            pubTitle = T.model.get("publicationTitle"),
            published = T.model.get("published"),
            message = STR.facebook_message,
            app_id = T.app.facebookAppId,
            caption = pubTitle + ", " + STR.date(published),
            picture = T.cropUrl();

        if (T.app.hostname) {
            var url_obj = new URL(url);
            url_obj.hostname = T.app.hostname;
            url = url_obj.href;
        }

        window.open(UrlUtil.shareFacebook(
            app_id, {
                display: "page",
                caption: caption,
                description: message,
                link: url,
                picture: picture
            }), "_blank");
    },

    onHlDocumentClicked: function() {
        var T = this,
            pubTitle = T.model.get("publicationTitle"),
            docTitle = T.model.get("documentTitle")||T.model.get("title"),
            published = T.model.get("published"),
            documentId = T.model.get("documentId")||T.model.get("id"),
            publicationId = T.model.get("publicationId");

        var r = window.confirm("Etes-vous sûr de vouloir définir " + pubTitle + " " + docTitle + " du " + STR.date(published) + " comme \"Une emblématique\" ?");
        if (r) {

            var hl = new HiglightedDocumentModel({
                documentId: documentId,
                publicationId: publicationId,
                publicationTitle: pubTitle,
                publicationDate: published
            }, {
                rnapi: T.rnapi
            });
            T.app.notify({
                text: STR.save_in_progress + "...",
                type: "info",
                timeout: 3000
            });
            hl.save(null, {
                success: function() {
                    T.app.notify({
                        text: STR.save_ok,
                        type: "info",
                        timeout: 1000
                    });
                },
                error: function() {
                    T.app.notify({
                        text: STR.unable_to_save,
                        type: "error",
                        timeout: 4000
                    });
                }
            });
        }
    },

    onDocumentOTDClicked: function() {
        var T = this,
            pubTitle = T.model.get("publicationTitle"),
            docTitle = T.model.get("documentTitle")||T.model.get("title"),
            published = T.model.get("published"),
            documentId = T.model.get("documentId")||T.model.get("id"),
            publicationId = T.model.get("publicationId");

        var r = window.confirm("Etes-vous sûr de vouloir définir " + pubTitle + " " + docTitle + " du " + STR.date(published) + " comme \"Une du jour\" ?");
        if (r) {

            var doc_otd = new DocumentOfTheDayModel({
                documentId: documentId,
                publicationId: publicationId,
                publicationTitle: pubTitle,
                publicationDate: published
            }, {
                rnapi: T.rnapi
            });
            T.app.notify({
                text: STR.save_in_progress + "...",
                type: "info",
                timeout: 3000
            });
            doc_otd.save(null, {
                success: function() {
                    T.app.notify({
                        text: STR.save_ok,
                        type: "info",
                        timeout: 1000
                    });
                },
                error: function() {
                    T.app.notify({
                        text: STR.unable_to_save,
                        type: "error",
                        timeout: 4000
                    });
                }
            });
        }
    },

    close: function() {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }

});